import React, { useState } from 'react';
import { Modal, Form, Button, Alert } from 'react-bootstrap';
import FalconCloseButton from 'components/common/FalconCloseButton';
import PropTypes from 'prop-types';

const SiteNameModal = ({ show, onHide, handleSiteName }) => {
  const [siteName, setSiteName] = useState('');
  const [showError, setShowError] = useState(false);

  const handleKeyDown = event => {
    if (event.key === 'Enter') {
      if (siteName !== '') {
        handleSiteName(siteName);
        setSiteName('');
        setShowError(false);
      } else {
        setShowError(true);
      }
    }
  };

  return (
    <>
      <Modal
        show={show}
        onHide={onHide}
        aria-labelledby="side-name-modal"
        backdrop="static"
        centered
      >
        <Modal.Header>
          <Modal.Title id="side-name-modal">Planting Site's Name</Modal.Title>
          <FalconCloseButton
            onClick={() => {
              setShowError(false);
              setSiteName('');
              onHide();
            }}
          />
        </Modal.Header>
        <Modal.Body>
          <Form.Control
            type="text"
            placeholder="Input name ..."
            onChange={({ target }) => setSiteName(target.value)}
            onKeyDown={handleKeyDown}
          />
          <br />
          {showError && (
            <Alert key="danger" variant="danger">
              Please enter a site name.
            </Alert>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="primary"
            type="submit"
            className="mt-3"
            onClick={() => handleSiteName(siteName)}
          >
            Submit
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

SiteNameModal.propTypes = {
  show: PropTypes.bool.isRequired,
  onHide: PropTypes.func.isRequired,
  handleSiteName: PropTypes.func
};

export default SiteNameModal;
